module.exports = __webpack_public_path__ + "static/img/h-07.a3a27b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/h-07.jpg
// module id = D+lC
// module chunks = 1